var Product_Filters = {

	is_dragging:false,

	init:function(){
		$(".shop-top-widget .show-results").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}
			$(".shop-top-widget form").submit();
		});

		$(".shop-top-widget .ui-slider-handle").on("touchstart mousedown", function(){
			Product_Filters.is_dragging = true;
			Product_Filters.moveHandle();
		});

		$(window).on("touchend mouseup", function(){
			Product_Filters.is_dragging = false;
		});


		Product_Filters.moveHandle();

	},
	moveHandle:function(){

		var _min_price = $(".shop-top-widget #min_price");
		var _max_price = $(".shop-top-widget #max_price");
		
		var _l_pos = Math.max(0, parseInt($(".ui-slider-handle:nth-child(2)").css("left")) - _min_price.width());
		var _r_pos = Math.max(_l_pos + _min_price.width() , Math.min($(".price_slider_amount").width() - _max_price.width() , parseInt($(".ui-slider-handle:nth-child(3)").css("left"))));
		
		_min_price.css({left:_l_pos});
		_max_price.css({left:_r_pos});
		

		if(Product_Filters.is_dragging == true){
			setTimeout(function(){
				Product_Filters.moveHandle();
			}, 40);
		}
	}
}

$(window).load(function(){
	if($(".woocommerce-shop").length){
		Product_Filters.init();
	}
});